export interface IGetSemitrailersFiltersDto {
    includeSharedFinished?: boolean;
    includeExternal?: boolean;
}
